<ng-container *ngIf="icon$ | async"></ng-container>
<ng-container *ngIf="loop$ | async"></ng-container>

<mat-icon *fuseIfOnDom><ng-content></ng-content></mat-icon>
